export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/web_banners.c1eb255.svg";